// TODO: Add languages from api
export const LANGUAGE_NAMES = {
  tr: {
    name: "Türkçe",
    code: "tr",
  },
  en: {
    name: "English",
    code: "en",
  },
  de: {
    name: "Deutsch",
    code: "de",
  },
  ar: {
    name: "العربية",
    code: "ar",
  },
  az: {
    name: "Azerbaijani",
    code: "az",
  },
  ru: {
    name: "Russian",
    code: "ru",
  },
};
